import axios from 'axios';
import { getLogisticsAPIUrl } from '../../../../services/env.service';

class LoopBackApi {
  private static instance: LoopBackApi;
  private readonly apiUrl: string;
  private constructor() {
    this.apiUrl = getLogisticsAPIUrl();
  }

  public static getInstance() {
    if (!this.instance) {
      this.instance = new LoopBackApi();
    }
    return this.instance;
  }

  public download(endpoint: string, filter: {} = {}) {
    const url = this.buildUrl(endpoint, filter);

    return axios.get(url, { responseType: 'blob' });
  }

  public downloadPost(endpoint: string, data) {
    const url = this.buildUrl(endpoint, {});
    return axios.post(url, data, { responseType: 'blob' });
  }

  public get<T = any>(endpoint: string, filter: {} = {}) {
    const url = this.buildUrl(endpoint, filter);
    return axios.get<T>(url);
  }

  public post(endpoint: string, data) {
    const url = this.buildUrl(endpoint, {});
    return axios.post(url, data);
  }

  public patch(endpoint: string, data) {
    const url = this.buildUrl(endpoint, {});

    return axios.patch(url, data);
  }

  public put(endpoint: string, data = {}) {
    const url = this.buildUrl(endpoint, {});

    return axios.put(url, data);
  }

  public delete(endpoint: string, data = {}) {
    const url = this.buildUrl(endpoint, {});

    return axios.delete(url, data);
  }

  private buildUrl(endPoint: string, filter: {}) {
    const query = this.parseFilters(filter);
    return `${this.apiUrl}/${endPoint}` + query;
  }

  private parseFilters(filter: {}) {
    let parsed = '';
    for (const key of Object.keys(filter)) {
      const glue = parsed === '' ? '?' : '&';
      parsed += `${glue}${key}=${JSON.stringify(filter[key])}`;
    }
    return parsed;
  }
}

const loopBackApi = () => LoopBackApi.getInstance();
export { loopBackApi };
